import { formatCurrency } from '../../utils/formatting';

// Labels and colors for scenario types
const TYPE_CONFIG = {
  'new-hire-support': { label: 'Support Hire', icon: '👤', color: 'bg-navy' },
  'new-hire-revenue': { label: 'Revenue Hire', icon: '💼', color: 'bg-deep-teal' },
  'one-time-expense': { label: 'One-Time Expense', icon: '📌', color: 'bg-rose' },
  'recurring-expense': { label: 'Recurring Expense', icon: '🔄', color: 'bg-rose' },
  'revenue-change': { label: 'Revenue Change', icon: '📈', color: 'bg-bullogic-blue' },
};

// Month names for display
const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export default function ScenarioCard({ scenario, monthlyCost, annualImpact, onToggle, onDelete, onEdit }) {
  const config = TYPE_CONFIG[scenario.type] || { label: scenario.type, icon: '?', color: 'bg-gray-400' };

  return (
    <div
      className={`bg-white rounded-[4px] shadow-[0_2px_6px_rgba(0,0,0,0.07)] p-4 border-l-4 ${
        scenario.active ? 'border-l-bullogic-blue' : 'border-l-gray-300 opacity-60'
      }`}
    >
      {/* Header row: type badge + toggle + delete */}
      <div className="flex items-center justify-between mb-2">
        <span className={`${config.color} text-white text-[10px] font-bold uppercase tracking-[0.08em] px-2 py-0.5 rounded-[3px]`}>
          {config.icon} {config.label}
        </span>
        <div className="flex items-center gap-2">
          {/* Toggle switch */}
          <button
            onClick={() => onToggle(scenario.id)}
            className={`relative w-9 h-5 rounded-full transition-colors ${
              scenario.active ? 'bg-bullogic-blue' : 'bg-gray-300'
            }`}
            title={scenario.active ? 'Disable scenario' : 'Enable scenario'}
          >
            <span
              className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform ${
                scenario.active ? 'left-[18px]' : 'left-0.5'
              }`}
            />
          </button>
          {/* Edit */}
          <button
            onClick={onEdit}
            className="text-[#888] hover:text-bullogic-blue text-[12px] leading-none"
            title="Edit scenario"
          >
            &#x270E;
          </button>
          {/* Delete */}
          <button
            onClick={() => onDelete(scenario.id)}
            className="text-[#888] hover:text-rose text-[14px] leading-none"
            title="Remove scenario"
          >
            &times;
          </button>
        </div>
      </div>

      {/* Title */}
      <h4 className="text-[14px] font-bold text-navy mb-1">{scenario.title}</h4>

      {/* Details */}
      <div className="flex items-center gap-4 text-[11px] text-[#888]">
        <span>
          Monthly: <span className={`font-bold ${monthlyCost < 0 ? 'text-rose' : 'text-deep-teal'}`}>
            {formatCurrency(monthlyCost)}
          </span>
        </span>
        <span>
          Annual: <span className={`font-bold ${annualImpact < 0 ? 'text-rose' : 'text-deep-teal'}`}>
            {formatCurrency(annualImpact)}
          </span>
        </span>
        {scenario.startMonth && (
          <span>Starts: {MONTH_NAMES[scenario.startMonth - 1]}</span>
        )}
      </div>
    </div>
  );
}
